// This is the header for the DEL Landing Page. It will be used to display the menu button, and username information.

import React from "react";
import { shallow } from "zustand/shallow";
import styles from "./LandingPageHeader.module.css";
import { useAppStore } from "../../../../store/appStore";
import { useUserState } from "../../../../context/user";
import { AppRefreshButton } from "../buttons/AppRefreshActions";

export const LandingPageHeader = () => {
  const { currentUser } = useUserState();
  const { toggleMenu } = useAppStore((state) => state.mainMenuActions);

  // Refresh Functions
  const fetchProjects = useAppStore((s) => s.projectsActions.fetchProjects);
  const fetchInactiveProjects = useAppStore(
    (s) => s.projectsActions.fetchInactiveProjects
  );
  const fetchTerminatedEmployees = useAppStore(
    (s) => s.employeesActions.fetchTerminatedEmployees
  );
  const fetchEmployees = useAppStore((s) => s.employeesActions.fetchEmployees);
  const fetchUnits = useAppStore((s) => s.unitsActions.fetchUnits);
  const fetchEmployeePositions = useAppStore(
    (s) => s.employeePositionsActions.fetchEmployeePositions
  );
  const fetchSamplingSites = useAppStore(
    (s) => s.samplingSitesActions.fetchSamplingSites
  );

  // Loading UI actions
  const showLoading = useAppStore((s) => s.loadingActions.showLoading);
  const hideLoading = useAppStore((s) => s.loadingActions.hideLoading);
  // Notification UI actions
  const { showNotification } = useAppStore(
    (s) => s.notificationActions,
    shallow
  );

  const handleRefresh = async () => {
    showLoading("Refreshing App Data...");
    try {
      await fetchProjects();
      await fetchInactiveProjects();
      await fetchTerminatedEmployees();
      await fetchEmployees();
      await fetchUnits();
      await fetchEmployeePositions();
      await fetchSamplingSites();
      console.log("Refreshing app data...");
    } catch (error) {
      hideLoading();
      showNotification({
        type: "error",
        title: "Error Refreshing App Data",
        message: "Please try again later.",
      });
      console.error("Error refreshing app data:", error);
    } finally {
      hideLoading();
      showNotification({
        type: "success",
        title: "App Data Refreshed",
        message: "App data has been refreshed successfully.",
      });
    }
  };

  return (
    <header className={styles.header} data-testid="landing-page-header">
      <div className={styles.headerLeft}>
        <div className={styles.menuButton}>
          <button onClick={() => toggleMenu()} data-testid="main-menu-button">
            ☰ Menu
          </button>
        </div>
      </div>
      <div className={styles.headerRight}>
        <div className={styles.settingsSection}>
          <AppRefreshButton refreshFunction={handleRefresh} />
        </div>
        <div className={styles.userInfo}>
          <h1>EWI DELs</h1>
          <p>{currentUser.username}</p>
        </div>
      </div>
    </header>
  );
};
